import Card from "@mui/material/Card";
import {baseUrl} from "../../config";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import * as React from "react";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";

export function VerificationImageItem ({item, imgWidth, onImageClick, onCheckChange}){
    const onChangeItemState =(e)=>{
        item.checkState = e.target.checked
        onCheckChange()
    }
    const isChecked =()=>{
        // console.log('isChecked item', item, item.checkState)
        return !!item.checkState
    }
    //console.log('ImageItem item', item)
    return (
            <div style={{position: 'relative'}} >
                <img
                    src={`${baseUrl}/img/${item.fileName}`}
                    alt={item.imagePath}
                    height={imgWidth}
                    width={imgWidth}
                    onClick={(event)=>onImageClick(item.id)}
                    loading="lazy"
                />

                {!!item.boundaries && item.boundaries.length>0?
                    item.boundaries.map((boundary,index)=>
                        <div key={index}
                             style={{
                                 position: 'absolute',
                                 zIndex: 2,
                                 left: imgWidth * boundary.leftX,
                                 top: imgWidth*boundary.topY
                             }}>
                            <Box
                                sx={{
                                    width: imgWidth * (boundary.rightX - boundary.leftX),
                                    height: imgWidth * (boundary.bottomY - boundary.topY),
                                    border: 1, borderColor: 'black',
                                }}
                                onClick={(event)=>onImageClick(item.id)}
                            />
                        </div>)
                    : null
                }

                <div style={{position: 'absolute', top: 0, left: 4, zIndex: 4}}>
                    <FormControlLabel
                        control={<Checkbox sx={{color: "#ffffff",'&.Mui-checked': {color: "yellow",},}}/>}
                        checked={isChecked()}
                        value={item.id}
                        onChange={onChangeItemState}
                        label={""}
                    />
                </div>
            </div>

    )
}
